module.exports = __webpack_public_path__ + "img/icon-ranking-2@3x.d9a9ee00.png";